var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.fileError
      ? _c("div", { staticClass: "invalid" }, [
          _c("h3", [_vm._v(_vm._s(_vm.fileError))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !Object.keys(_vm.importerErrors).length &&
    !Object.keys(_vm.importerWarnings).length
      ? _c("div", { staticClass: "valid" })
      : _vm._e(),
    _vm._v(" "),
    Object.keys(_vm.importerErrors).length
      ? _c("div", { staticClass: "invalid" }, [
          _c("h3", [
            _vm._v(
              "Errors found in file. Data was not imported. Resolve the following issues and retry:"
            ),
          ]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table table-hover table-tags table-data" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.importerErrors, function (talentErrors) {
                return _vm._l(talentErrors, function (lineError, lineIndex) {
                  return _c("tr", { key: lineIndex }, [
                    _c("td", { staticClass: "w-1/10" }, [
                      _vm._v(
                        _vm._s(
                          isNaN(lineIndex) ? "" : parseInt(lineIndex) + 1
                        ) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        typeof lineError === "string"
                          ? _c("span", [_vm._v(_vm._s(lineError))])
                          : _vm._l(
                              lineError,
                              function (columnErrors, columnIndex) {
                                return _c(
                                  "div",
                                  { key: columnIndex },
                                  _vm._l(columnErrors, function (error, index) {
                                    return _c("div", { key: index }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(error) +
                                          "\n                "
                                      ),
                                    ])
                                  }),
                                  0
                                )
                              }
                            ),
                      ],
                      2
                    ),
                  ])
                })
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    Object.keys(_vm.importerWarnings).length
      ? _c("div", { staticClass: "invalid" }, [
          _c("h3", [_vm._v("Warnings found in file.")]),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table table-hover table-tags table-data" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.importerWarnings, function (talentWarnings) {
                return _vm._l(talentWarnings, function (lineError, lineIndex) {
                  return _c("tr", { key: lineIndex }, [
                    _c("td", { staticClass: "w-1/10" }, [
                      _vm._v(_vm._s(parseInt(lineIndex) + 1) + " "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      _vm._l(lineError, function (columnErrors, columnIndex) {
                        return _c("div", { key: columnIndex }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(columnErrors) +
                              "\n            "
                          ),
                        ])
                      }),
                      0
                    ),
                  ])
                })
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "w-1/10" }, [_vm._v("Row")]),
      _vm._v(" "),
      _c("th", [_vm._v("Message")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { staticClass: "w-1/10" }, [_vm._v("Row")]),
      _vm._v(" "),
      _c("th", [_vm._v("Message")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }